import { combineReducers } from 'redux';

import themeReducer from './themeReducers';
import insuranceReducers from './insuranceReducers';

export default combineReducers({
	themeReducer, insuranceReducers
});
